import { render, staticRenderFns } from "./PatentView.vue?vue&type=template&id=e01c1418"
import script from "./PatentView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatentView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PatentView.vue?vue&type=style&index=0&id=e01c1418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports